// extracted by mini-css-extract-plugin
export var container = "styles-module--container--6f4a8";
export var imageContainer = "styles-module--imageContainer--1c9dd";
export var imageContent = "styles-module--imageContent--b4469";
export var title = "styles-module--title--40ffa";